/* eslint-disable react-hooks/exhaustive-deps */
import Separator from "@/components/Common/Separator";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import StudentDashboardSidebar from "@/components/Student/StudentDashboardSidebar";
import PageHead from "@/pages/Head";
import BackToTop from "@/pages/backToTop";
import { Fragment, useEffect, useState } from "react";
import SessionModals from "./dashboard/SessionModal";
import AnnouncementModal from "./dashboard/AnnouncementModal";
import axios from "axios";
import { openModal } from "@/pages/student/question/test/initiate/[id]";
import { getCookie } from "@/context/utilities";

const StudentDashboardLayout = ({
  children,
  title,
  sidebar,
  brand,
  submitAnnouncements,
}) => {
  const [announcements, setAnnouncements] = useState([]);
  const [allAnnouncements, setAllAnnouncements] = useState([]);
  const today = new Date();
  const startOfDay = new Date(today.setHours(0, 0, 0, 0)); // Today at 00:00:00
  const endOfDay = new Date(today.setHours(23, 59, 59, 999)); // Today at 23:59:59
  useEffect(() => {
    getAnnouncements();
  }, []);

  const getAnnouncements = () => {
    axios
      .get(
        `/api/announcements?id=${brand._id}&start=${startOfDay}&end=${endOfDay}`
      )
      .then((res) => {
        if (res.data.data.length > 0) {
          const announced = res.data.data.filter((i) => {
            const announcedState = getCookie(i._id);

            return !announcedState;
          });
          setAllAnnouncements(res.data.data);
          setAnnouncements(announced);
          submitAnnouncements && submitAnnouncements(res.data.data);
          if (announced.length > 0) {
            openModal("announcements");
          }
        }
      })
      .catch((err) => {
      });
  };

  return (
    <Fragment>
      <PageHead title={title} />

      <MobileMenu />
      <HeaderStyleTen
        announcements={allAnnouncements}
        brand={brand}
        headerSticky="rbt-sticky"
        headerType=""
      />
      <Cart />
      <SessionModals />
      <AnnouncementModal announcements={announcements} />
      <div className="rbt-page-banner-wrapper">
        <div className="rbt-banner-image" />
      </div>
      <div className="rbt-dashboard-area rbt-section-overlayping-top rbt-section-gapBottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row g-5">
                {sidebar && (
                  <div className="col-lg-3 d-none d-lg-block">
                    <div className="rbt-default-sidebar sticky-top rbt-shadow-box rbt-gradient-border">
                      <StudentDashboardSidebar />
                    </div>
                  </div>
                )}
                <div className={sidebar ? "col-lg-9" : "col-lg-12"}>
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <BackToTop />
      <Separator />
      {/* <FooterOne brand={brand} /> */}
    </Fragment>
  );
};

export default StudentDashboardLayout;
